"use client";

import * as React from "react";

/** Mưa hoa/kim tuyến rơi từ trên xuống trong ~1.5s — mừng khi trả lời đúng. */
const CONFETTI_EMOJIS = ["🎉", "🎊", "🌸", "🌼", "⭐", "✨", "💫", "🏵️", "🎈"];

export function Confetti() {
  const pieces = React.useMemo(
    () =>
      Array.from({ length: 30 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        emoji: CONFETTI_EMOJIS[Math.floor(Math.random() * CONFETTI_EMOJIS.length)]!,
        size: 2.4 + Math.random() * 2.8,
        dur: 1.2 + Math.random() * 0.9,
        delay: Math.random() * 0.4,
        dx: Math.random() * 40 - 20,
        r: Math.random() * 900 - 450,
      })),
    []
  );
  return (
    <div className="pointer-events-none absolute inset-0 z-50 overflow-hidden" aria-hidden>
      {pieces.map((p) => (
        <span
          key={p.id}
          className="orx-confetti"
          style={
            {
              left: `${p.left}%`,
              fontSize: `${p.size}cqh`,
              animation: `orxFall ${p.dur}s ease-in ${p.delay}s forwards`,
              "--dx": `${p.dx}cqw`,
              "--r": `${p.r}deg`,
            } as React.CSSProperties
          }
        >
          {p.emoji}
        </span>
      ))}
    </div>
  );
}
